import styled from 'styled-components';

export const H1 = styled.h1`
  font-size: x-large;
`;

export const H2 = styled.h2`
  font-size: large;
`;

export const H3 = styled.h3`
  font-size: medium;
`;
